module.exports = __webpack_public_path__ + "static/img/PC-7.a18ecbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcyixuekao/PC-7.png
// module id = Egv5
// module chunks = 0